import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useAuth } from '../../hooks/useAuth';
import { Analytics } from '../../lib/analytics';

interface GuestConversionCTAProps {
  gameId: string;
}

/**
 * GuestConversionCTA — "Sign Up Free" button shown in GameFrame header for anonymous users.
 *
 * Visibility: isLoaded && !isSignedIn (Clerk state only — IS-INV-034: never JWT inspection).
 * Fires anonymous_conversion_cta_shown on mount, anonymous_conversion_cta_clicked on click.
 */
export function GuestConversionCTA({ gameId }: GuestConversionCTAProps) {
  const { isLoaded, isSignedIn } = useUser();
  const { openAuthModal } = useAuth();

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      Analytics.trackAnonymousConversionCTAShown({ gameId });
    }
  }, [isLoaded, isSignedIn, gameId]);

  if (!isLoaded || isSignedIn) {
    return null;
  }

  const handleClick = () => {
    Analytics.trackAnonymousConversionCTAClicked({ gameId });
    openAuthModal('sign-up');
  };

  return (
    <button
      onClick={handleClick}
      className="px-3 py-1.5 bg-sport-accent text-white rounded-md font-emphasis text-sm
                 font-medium uppercase-tracked hover:opacity-90 transition-opacity duration-200"
    >
      Sign Up Free
    </button>
  );
}
